<template>
  <el-dialog :visible.sync="innerVisible" :title="title" width="600px" @close="closeHandler">
    <div class="edi-check-result-display single-row-style">
      <img :src="falseIcon">
      <div style="padding-left: 20px;">{{ params.labelText }}</div>
    </div>
    <div v-for="(item,index) in dataSource" :key="index" :data="item" style="display: flex;justify-content: space-between;margin-top: 5px;margin-bottom:2px;padding: 1.5px;align-items: center;" class="edi-check-item-renderer">
      <div style="flex-grow:1;">{{ item.name }}</div>
      <img v-if="item.type==='failure'" :src="icon" height="16px">
    </div>
    <span slot="footer">
      <el-button no="close" type="danger" @click="closeHandler">{{ $t('Message.Close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import rejectIcon from '@/assets/reject-x16.png'
import falseIcon from '@/assets/false-x32.png'

export default {
  name: 'EdiScfiPromptDialog',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      dataSource: [],
      title: '',
      labelText: '',
      currentState: '',
      icon: rejectIcon,
      falseIcon: falseIcon
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.dataSource = this.params.checkMessageList
        this.title = this.params.title
        this.currentState = this.params.currentState
        this.labelText = this.params.labelText
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    closeHandler() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.edi-check-item-renderer{
  background: #d9f8ff;
  border: 1px solid #b1e2ff;
}
.single-row-style {
  border: 1px solid #E61B0F;
  background-color: #FFC7C0
}
.edi-check-result-display{
  display: flex;
  height: 50px;
  align-items: center;
  margin-top: 5px;
}
</style>
